/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostProcessingPeriodMemoryForSaas extends models.BaseCostProcessingPeriodMemory {
    getFixupPrototypeFunction() { return CostProcessingPeriodMemoryForSaas.fixupPrototype; }

    static newInstance(model: Partial<CostProcessingPeriodMemoryForSaas>): CostProcessingPeriodMemoryForSaas {
        let obj = Object.assign(new CostProcessingPeriodMemoryForSaas(), model);
        CostProcessingPeriodMemoryForSaas.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostProcessingPeriodMemoryForSaas>): CostProcessingPeriodMemoryForSaas {
        if (!model) return null;
        return CostProcessingPeriodMemoryForSaas.newInstance(<CostProcessingPeriodMemoryForSaas> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostProcessingPeriodMemoryForSaas) {
        if (!obj) return;

        models.CostProcessingPeriodMemoryForSaas.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostProcessingPeriodMemoryForSaas): boolean {
        if (models.BaseCostProcessingPeriodMemory.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostProcessingPeriodMemoryForSaas.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Fully processed reports
     */
    processed_reports: Array<string>;

    /**
     * Missing reports
     */
    missing_reports: Array<string>;

}
